class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.disclosures = this.header.querySelectorAll('header-menu');
    this.currentScrollTop = 0;

    this.setHeaderHeight();
    this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
    this.mediaQueryList = window.matchMedia('(max-width: 990px)');
    this.mediaQueryList.addEventListener('change', this.boundSetHeaderHeight);

    this.boundOnScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.boundOnScroll, { passive: true });

    // Measure header position after layout stabilizes
    this.updateHeaderBounds();
    window.addEventListener('load', () => this.updateHeaderBounds());

    // Observe header resizes (if promo bar changes height)
    this.resizeObserver = new ResizeObserver(() => this.updateHeaderBounds());
    this.resizeObserver.observe(this.header);
  }

  disconnectedCallback() {
    this.mediaQueryList.removeEventListener('change', this.boundSetHeaderHeight);
    window.removeEventListener('scroll', this.boundOnScroll, { passive: true });
    this.resizeObserver.disconnect();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  updateHeaderBounds() {
    const rect = this.header.getBoundingClientRect();
    this.headerBounds = {
      top: rect.top + window.scrollY,
      bottom: rect.bottom + window.scrollY,
    };
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isSticky = this.header.classList.contains('shopify-section-header-sticky');
    if (scrollTop < this.currentScrollTop) {
      // SCROLLING UP (Reset/Reveal Logic)
      if (scrollTop <= this.headerBounds.top && isSticky) {
        requestAnimationFrame(this.reset.bind(this));
      } else {
        const isHidden = this.header.classList.contains('shopify-section-header-hidden');
        isHidden && requestAnimationFrame(this.reveal.bind(this));
      }
    } else if (scrollTop > this.currentScrollTop) {
      // SCROLLING DOWN (Hide Logic)
      if (scrollTop > this.headerBounds.bottom) {
        const isHidden = this.header.classList.contains('shopify-section-header-hidden');
        if (!isHidden) {
          const containsOpenMenu = Array.from(this.disclosures || []).some((disclosure) =>
            disclosure.mainDetailsToggle.hasAttribute('open')
          );
          !containsOpenMenu && requestAnimationFrame(this.hide.bind(this));
        }
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);
